import { createShape, metadata, ShapeDecodeError } from "../common/mod.js";
export function option($some, none) {
    if ($some.metadata.some((x) => x.factory === option && x.args[1] === none)) {
        throw new Error("Nested option shape will not roundtrip correctly");
    }
    return createShape({
        metadata: metadata("$.option", (option), $some, ...(none === undefined ? [] : [none])),
        staticSize: 1 + $some.staticSize,
        subEncode(buffer, value) {
            if ((buffer.array[buffer.index++] = +(value !== none))) {
                $some.subEncode(buffer, value);
            }
        },
        subDecode(buffer) {
            switch (buffer.array[buffer.index++]) {
                case 0:
                    return none;
                case 1: {
                    const value = $some.subDecode(buffer);
                    if (value === none) {
                        throw new ShapeDecodeError(this, buffer, "Some(None) will not roundtrip correctly");
                    }
                    return value;
                }
                default:
                    throw new ShapeDecodeError(this, buffer, "Option discriminant neither 0 nor 1");
            }
        },
        subAssert(assert) {
            if (assert.value === none)
                return;
            $some.subAssert(assert);
        },
    });
}
//# sourceMappingURL=option.js.map